import { SalesQualificationData } from '@/types/onboarding/salesQualification';

export const formatNumber = (value: string) => {
  const digits = (value || '').toString().replace(/\D/g, '');
  if (!digits) return '';
  try {
    return Number(digits).toLocaleString('en-US');
  } catch (e) {
    return digits;
  }
};

export const createDecisionMakerHelpers = (
  formData: Partial<SalesQualificationData>,
  updateFormData: (field: string, value: unknown) => void,
) => {
  const addDecisionMaker = () => {
    const current = formData.decisionMakers || [];
    updateFormData('decisionMakers', [
      ...current,
      { name: '', title: '', email: '', influence: '', role: '' },
    ]);
  };

  const updateDecisionMaker = (index: number, field: string, value: string) => {
    const current = formData.decisionMakers || [];
    const updated = current.map((dm, i) => (i === index ? { ...dm, [field]: value } : dm));
    updateFormData('decisionMakers', updated);
  };

  const removeDecisionMaker = (index: number) => {
    const current = formData.decisionMakers || [];
    updateFormData(
      'decisionMakers',
      current.filter((_, i) => i !== index),
    );
  };

  return { addDecisionMaker, updateDecisionMaker, removeDecisionMaker };
};

export const createArrayUpdateHelper = (
  formData: Partial<SalesQualificationData>,
  updateFormData: (field: string, value: unknown) => void,
) => {
  return (field: string, value: string, checked: boolean) => {
    const current = (formData[field as keyof SalesQualificationData] as string[]) || [];
    if (checked) {
      updateFormData(field, [...current, value]);
    } else {
      updateFormData(
        field,
        current.filter((item) => item !== value),
      );
    }
  };
};
